import React from "react";
import moment from "moment";
import ipRangeCheck from "ip-range-check";
import GeoLocation from "../components/GeoLocation";
import { FormattedMessage } from "react-intl";

export const ipIsInternal = (ipAddress) => {
    return ipRangeCheck(ipAddress, ["127.0.0.1", "192.168.0.0/16", "172.16.0.0/12", "10.0.0.0/8"]);
};

export const getSessionDetails = (sessionData) => {
    const label = (name: string) => <FormattedMessage id={`user_session.${name}`} />;

    let title = label("unknown");
    let subTitle = "";
    let lastUse = label("never");
    let location = label("unknown");

    const ipAddr = sessionData["ip"];

    if (ipAddr) {
        if (ipIsInternal(ipAddr)) location = label("private");
        else location = <GeoLocation ip={ipAddr} />;
    }

    const last_time = sessionData["last_use"] || sessionData["created"];
    if (last_time) {
        const lastUseMilliSeconds = moment().diff(moment(last_time));
        if (lastUseMilliSeconds > 60 * 1000)
            lastUse = <span>{moment.duration(-lastUseMilliSeconds).humanize(true)}</span>;
        else lastUse = label("just_now");
    }

    if (sessionData["user_agent"]) {
        const userAgent = sessionData["user_agent"];
        if (userAgent["client"]["name"].startsWith("Deverto")) {
            title = userAgent["client"]["name"];
            subTitle = `${userAgent["os"]["name"]}`;
        } else {
            title = userAgent["os"]["name"];
            subTitle = userAgent["client"]["name"];
        }
    }

    if (sessionData["type"] === "service") {
        title = label("service");
    }

    return { title, subTitle, location, lastUse };
};
